import {texture} from "p3";
import definitions from "../../definitions";
import GameScene from "../../scenes/GameScene";

export default class TutorialMapControls extends PIXI.Container {
    constructor() {
        super();

        this._icon = null;
        this._tl = null;

        this.init();
    }

    init() {

        this._icon = new PIXI.Sprite(texture('tutorial_pointer'));
        this._icon.anchor.set(0.5);
        this.addChild(this._icon);

        if (!PIXI.utils.isMobile.any) {
            this._icon.rotation = -125 * PIXI.DEG_TO_RAD;
        }

        this._holdUp();

        this._tl = new gsap.timeline({repeat:-1});
        this._tl.to(this._icon, 0.4, {delay:0.5, y:-100, ease:Sine.easeInOut, onComplete: this._holdDown.bind(this)});
        this._tl.to(this._icon, 1, {delay:0.3, y:100, ease:Sine.easeInOut, onComplete: this._holdUp.bind(this)});
        this._tl.to(this._icon, 0.3, {delay:0.3, y:0, ease:Sine.easeInOut});
        this._tl.to(this._icon, 0.4, {delay:0.5, x:-100, ease:Sine.easeInOut, onComplete: this._holdDown.bind(this)});
        this._tl.to(this._icon, 1, {delay:0.3, x:100, ease:Sine.easeInOut, onComplete: this._holdUp.bind(this)});
        this._tl.to(this._icon, 0.3, {delay:0.3, x:0, ease:Sine.easeInOut});
    }

    _holdDown(){
        if (PIXI.utils.isMobile.any) {
            this._icon.texture = texture('tutorial_hand_press');
        } else {
            this._scaleTween = gsap.to(this._icon.scale, 0.2, {x:0.8, y:0.8, ease:Sine.easeInOut});
        }
    }

    _holdUp(){
        if (PIXI.utils.isMobile.any) {
            this._icon.texture = texture('tutorial_hand_point');
        } else {
            this._scaleTween = gsap.to(this._icon.scale, 0.2, {x:1, y:1, ease:Sine.easeInOut});
        }
    }

    destroy() {

        this._tl.kill();
        if(this._scaleTween) {
            this._scaleTween.kill();
        }

        super.destroy();
    }

    update() {

    }
}